// import Create from "./Create";
import Stats from "./Stats";
import Table from "./Table";

function Transactions() {
  return (
    <div>
        <Stats />
        <Table />
    </div>
  );
}

export default Transactions;
